<template>
    <div class="security">
        <div class="label">账号密码</div>
        <div class="tips">当前密码强度: <span>强</span></div>
        <div class="edit" @click="editPassShow = true">
            <span>修改</span>
        </div>
        <div class="label">绑定手机</div>
        <div class="tips">已绑定手机:{{user.mobile}}</div>
        <div class="edit" @click="editPhoShow = true">
            <span>修改</span>
        </div>
        <!--修改密码-->
        <WxMessageBox :show="editPassShow" @save="editPassSave" @canse="editPassCanse">
            <div slot="content">
                <div class="edit_security">
                    <div class="form_item">
                        <span class="lable">原始密码:</span>
                        <div class="input">
                            <el-input v-model="passForm.oldPass" placeholder="请输入原始密码" size="mini" type="password"></el-input>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="lable">新密码:</span>
                        <div class="input">
                            <el-input v-model="passForm.newPass" placeholder="请输入新密码" size="mini"  type="password"></el-input>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="lable">确认密码:</span>
                        <div class="input">
                            <el-input v-model="passForm.confirmPass" placeholder="请再次输入密码" size="mini"  type="password"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
        <!--修改手机-->
        <WxMessageBox :show="editPhoShow" @save="editPhoSave" @canse="editPhoCanse">
            <div slot="content">
                <div class="edit_security">
                    <div class="form_item">
                        <span class="lable">新手机号:</span>
                        <div class="input">
                            <el-input v-model="phoForm.pho" placeholder="请输入新手机号" size="mini"></el-input>
                        </div>
                    </div>
                    <div class="form_item">
                        <span class="lable">短信验证码 :</span>
                        <div class="input code">
                            <el-input v-model="phoForm.code" placeholder="请输入验证码" size="mini"></el-input>
                            <el-button :disabled="codeDisabled" @click="getCode" size="mini">{{codeMsg}}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
    import {getUserInfo,modifyPassword,modifyMobile,sendsms} from '@/api/api'
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "security",
        data(){
            return{
                editPassShow:false,
                editPhoShow:false,
				user:{},
                passForm:{
                    oldPass:'',
                    newPass:'',
                    confirmPass:''
                },
                phoForm:{
                    pho:'',
                    code:'',
					type:3,
                },
                codeDisabled: false,
                countdown: 60,
                codeMsg: '获取验证码',
                timer: null
            }
        },
		
		mounted() {
			this.get_user_info()
		},
        methods:{
			
			
			get_user_info(){
			    getUserInfo().then(resp=>{			        
			        this.user=resp;
			    })
			},
            // 修改密码弹窗确认
            editPassSave(){
				
				modifyPassword(this.passForm).then(resp=>{
					if(resp.status==1){
						this.$message.success(resp.msg)
						this.editPassShow = false
					}else{
						this.$message.error(resp.msg)
					}
					 //this.editPassShow = false
				})
               
            },
            // 修改密码弹窗取消
            editPassCanse(){
				// 获取验证码
            
                this.editPassShow = false
            },
            // 修改手机弹窗确认
            editPhoSave(){
				modifyMobile(this.phoForm).then(resp=>{
					if(resp.status==1){
						this.$message.success(resp.msg)
						this.editPhoShow = false
						this.get_user_info()
					}else{
						this.$message.error(resp.msg)
					}
				})
               
            },
            // 修改手机弹窗取消
            editPhoCanse(){
                this.editPhoShow = false
            },
			// 获取验证码
/* 			            getCode() {
			                // 验证码60秒倒计时
			                if (!this.timer) {
			                    this.timer = setInterval(() => {
			                        if (this.countdown > 0 && this.countdown <= 60) {
			                            this.countdown--;
			                            if (this.countdown !== 0) {
			                                this.codeDisabled = true;
			                                this.codeMsg = "重新发送(" + this.countdown + ")";
			                            } else {
			                                clearInterval(this.timer);
			                                this.codeMsg = "获取验证码";
			                                this.countdown = 60;
			                                this.timer = null;
			                                this.codeDisabled = false;
			                            }
			                        }
			                    }, 1000)
			                }
			            }, */
            // 获取验证码
            getCode() {
                // 验证码60秒倒计时
               if (!this.isPhone(this.phoForm["pho"])) {
               	this.$message.error('手机号码错误');
               	return false
               }
               	sendsms(this.phoForm).then(resp => {
               		console.log(resp)
               		if (resp.status === 1) {
               			this.$message.success(resp.msg)
               		//	if (!this.timer) {
               				this.timer = setInterval(() => {
               					if (this.countdown > 0 && this.countdown <= 60) {
               						this.countdown--;
               						if (this.countdown !== 0) {
               							this.codeMsg = "重新发送(" + this.countdown + ")";
               						} else {
               							clearInterval(this.timer);
               							this.codeMsg = "获取验证码";
               							this.countdown = 60;
               							this.timer = null;
               							this.codeDisabled = false;
               
               						}
               					}
               				}, 1000)
               			//}
               		} else {
               			this.$message.error(resp.msg);
               		}
               	}).catch(error => {
               		console.log("e")
               	})
            }, 
        },
        components: {
            WxMessageBox
        }
    }
</script>

<style scoped lang="less">
    .security{
        padding: 40px 15%;
        .label{
            font-size: 18px;
            color: #fff;
            padding: 12px 0 7px 0;
        }
        .tips{
            font-size: 16px;
            color: #858FA9;
            span{
                color: #2D99FF;
            }
        }
        .edit{
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: rgba(45, 153, 255, 0.3);
            margin-top: 15px;
            span{
                float: right;
                font-size: 16px;
                color: #fff;
                padding-right: 25px;
                cursor: pointer;
            }
        }
    }
</style>
